
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  brandList,
  cancelBrand, cancelVoidBrand,
  deleteBrand,
  queryAllBrandSearchStates,
  updateRemark
} from "@/api/brand";
import {uploadOtherInfo} from "@/api/package";
import {firstUploadShellPackage} from "@/api/shell-package";
@Component({
  name: "brandManagement",
  components: {
    CreateBrand: () => import("./components/index.vue"),
    Pagination,
  },
})
export default class extends Vue {
  private listLoading = true;
  private showCreateBrandDialog = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    customerId: null,
    brandState: null,
    nameKeyword:null
  };
  public searchForm = [
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      type: "input",
      value: "",
      placeholder: "",
      readonly: true,
    },
    {
      label: "客人国家",
      prop: "nation",
      key: "nation",
      type: "input",
      value: "",
      placeholder: "",
      readonly: true,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      type: "input",
      options: [],
      value: "",
      placeholder: "",
      readonly: true,
    },
    {
      label: "销售助理",
      prop: "saleAssistant",
      key: "saleAssistant",
      type: "input",
      value: "",
      placeholder: "",
      readonly: true,
    },
    {
      label: "品牌",
      prop: "nameKeyword",
      key: "nameKeyword",
      type: "input",
      value: "",
      placeholder: "请输入品牌",
    },
    {
      label: "品牌类型",
      prop: "brandState",
      key: "brandState",
      type: "select",
      value: "",
      placeholder: "正常使用",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "品牌名称",
      prop: "name",
      key: "name",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createDate",
      key: "createDate",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "状态",
      prop: "brandState",
      key: "brandState",
      show: true,
      fixed: true,
      disabled: false,
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "装箱资料",
      prop: "packageInfoCount",
      key: "packageInfoCount",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "壳体包装",
      prop: "shellPackageCount",
      key: "shellPackageCount",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "额外信息",
      prop: "otherInfoCount",
      key: "otherInfoCount",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "作废",
          code: "",
          click: "cancel",
          key: "brandState",
          value: "正常使用",
        },
        {
          name: "取消作废",
          code: "",
          click: "cancelVoid",
          key: "brandState",
          value: "已作废",
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
        {
          name: "跳转到",
          type: "more",
          actions: [
            {
              name: "装箱资料",
              code: '',
              click: "jumpToPackingInfo"
            },
            {
              name: "壳体包装",
              code: '',
              click: "jumpToShellPackage"
            },
            {
              name: "额外信息",
              code: '',
              click: "jumpToOtherInfo"
            }
          ]
        }
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;
  private customerInfo = {} as any;
  private customerId = "" as any;

  created() {
    const json =  decodeURIComponent(this.$route.query.item as string)
    this.customerInfo = JSON.parse(json);
    this.customerId = this.customerInfo.customerId;
    this.searchForm[0].value = this.customerInfo.customerAbbr;
    this.searchForm[1].value = this.customerInfo.nation;
    this.searchForm[2].value = this.customerInfo.seller;
    this.searchForm[3].value = this.customerInfo.saleAssistant;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getBrandSearchAllStates();
    this.getList();
  }


  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    this.listParam.customerId = this.customerId;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    console.log("params", params)
    this.listLoading = false;
    const { total, list }: any = await brandList(params);
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // 删除品牌
  public async handleDelete(scope) {
    await deleteBrand(scope.row.id)
    .then(() => {
      this.$notify({
        title: "成功",
        message: "删除成功",
        type: "success",
        duration: 2000,
      });
    })
    .catch((err) => {
      console.log(err);
    });
    await this.getList();
  }

  public querySearch(data) {
    this.listParam = {...data};
    this.table.pageNumber = 1;
    this.getList();
  }

  private async getBrandSearchAllStates() {
   const states:any =  await queryAllBrandSearchStates();
   this.searchForm[5].options = states;
  }
  // 更新备注
  private async handleRemark(row:any) {
    await updateRemark(row.id, row.remark)
    .then(() => {
      this.$notify({
      title: "成功",
      message: "更新备注成功",
      type: "success",
      duration: 2000,
    });
    })
    .catch((err) => {
      console.log(err);
    });
    await this.getList();
  }

  private updateShowDialog(whetherOpenDialog:boolean){
    this.showCreateBrandDialog = whetherOpenDialog;
  }

    //creatBrand回调方法
  private async handleSuccess(){
    this.showCreateBrandDialog = false;
    await this.getList();
  }
  // 跳转页面
  private jumpToPackingInfo(scope) {
    this.$router.push(`/packingMaterialManagement?customerId=${this.customerId}`
        +`&customerBrand=${scope.row.name}`
        +`&customerBrandId=${scope.row.id}`
        +`&customerAbbr=${this.customerInfo.customerAbbr}`
        +`&seller=${this.customerInfo.seller}`
        +`&saleAssistant=${this.customerInfo.saleAssistant}`);
  }

   private jumpToShellPackage(scope){
    this.$router.push(`/shellPackageInfoManagement?customerId=${this.customerId}`
        + `&customerBrand=${scope.row.name}`
        + `&customerBrandId=${scope.row.id}`
        + `&customerAbbr=${this.customerInfo.customerAbbr}`
        + `&seller=${this.customerInfo.seller}`
        + `&saleAssistant=${this.customerInfo.saleAssistant}`);
  }

   private jumpToOtherInfo(scope){
    let customerInfo = {
      customerId: this.customerId,
      brand: scope.row.name,
      customerAbbr: this.customerInfo.customerAbbr,
      seller: this.customerInfo.seller,
      saleAssistant: this.customerInfo.saleAssistant,
      brandId: scope.row.id
    }
    let item = encodeURIComponent(JSON.stringify(customerInfo));
    this.$router.push(`/otherInfoManagement?item=${item}`);
  }
  // 作废
  private async cancel(scope) {
    await cancelBrand(scope.row.id).then(() => {
      this.$notify({
        title: "成功",
        message: "作废成功",
        type: "success",
        duration: 2000,
      });
    }).catch((err) => {
      console.error(err);
    })
    await this.getList();
  }

  // 取消作废
  private async cancelVoid(scope) {
    await cancelVoidBrand(scope.row.id).then(() => {
      this.$notify({
        title: "成功",
        message: "取消作废成功",
        type: "success",
        duration: 2000,
      });
    }).catch((err) => {
      console.error(err);
    })
    await this.getList();
  }

   private async handleUpload(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.customerId);
    formData.append("cover", 'false');
    formData.append("autoIncrementSn", 'false');
    await uploadOtherInfo(formData)
      .then(() => {
        loading.close();
        this.confirmSuccess();
      })
      .catch((err) => {
        loading.close();
        console.error(err)
      });
  }

  private async uploadShellPackage(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.customerId);
    await firstUploadShellPackage(formData)
        .then(() => {
          loading.close();
          this.confirmSuccess();
        })
        .catch((err) => {
          loading.close();
          console.error(err)
        });
  }

  private confirmSuccess() {
    (this.$refs.table as any).$refs.table.clearSelection();
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
}
